import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const VolumeControl = ({ 
  volume = 0.7, 
  onVolumeChange,
  isMuted = false,
  onMuteToggle 
}) => {
  const [showSlider, setShowSlider] = useState(false);

  const getVolumeIcon = () => {
    if (isMuted || volume === 0) return 'VolumeX';
    if (volume < 0.5) return 'Volume1';
    return 'Volume2';
  };

  return (
    <div className="volume-control relative flex items-center gap-3">
      <Button
        variant="ghost"
        size="icon"
        onClick={onMuteToggle}
        onMouseEnter={() => setShowSlider(true)}
        onMouseLeave={() => setShowSlider(false)}
        aria-label={isMuted ? 'Включить звук' : 'Выключить звук'}
      >
        <Icon 
          name={getVolumeIcon()} 
          size={20} 
          color="var(--color-foreground)" 
        />
      </Button>
      <div 
        className={`volume-slider transition-all duration-200 ${showSlider ? 'opacity-100 w-24' : 'opacity-0 w-0'}`}
        onMouseEnter={() => setShowSlider(true)}
        onMouseLeave={() => setShowSlider(false)}
      >
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={isMuted ? 0 : volume}
          onChange={(e) => onVolumeChange(parseFloat(e?.target?.value))}
          className="w-full h-1 bg-muted rounded-full appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-primary [&::-webkit-slider-thumb]:cursor-pointer"
          aria-label="Громкость"
        />
      </div>
    </div>
  );
};

export default VolumeControl;